import { FiservCardLockedReasonsEnum } from '@common-fe/common-fe';

export const GET_CARDS_QUERY_PARAMS_KEYS = {
  EMPLOYEE_ID: 'employee_id',
  DEPENDENT_ID: 'dependent_id',
};
export const ROOT_DEPENDENT_ID = 'none';

export const CARD_LOCKED_REASONS_OPTIONS = [
  { key: FiservCardLockedReasonsEnum.REPAYMENT_REQUIRED, value: FiservCardLockedReasonsEnum.REPAYMENT_REQUIRED, title: 'Repayment Required' },
  { key: FiservCardLockedReasonsEnum.DOCUMENTATION_REQUIRED, value: FiservCardLockedReasonsEnum.DOCUMENTATION_REQUIRED, title: 'Documentation Required' },
  { key: FiservCardLockedReasonsEnum.FRAUD_DETECTED, value: FiservCardLockedReasonsEnum.FRAUD_DETECTED, title: 'Fraud Detected' },
  { key: FiservCardLockedReasonsEnum.CARDHOLDERS_REQUEST, value: FiservCardLockedReasonsEnum.CARDHOLDERS_REQUEST, title: 'Cardholders Request' },
];